import { reportExpression } from '../../util.js';

export const execute = (node, context) => {

  const {
    appearance
  } = node;

  if (appearance && (
    appearance.prefixAdorner !== undefined ||
    appearance.suffixAdorner !== undefined
  )) {
    return (
      reportExpression(node, [ 'appearance', 'prefixAdorner' ], 'Prefix', context) &&
      reportExpression(node, [ 'appearance', 'suffixAdorner' ], 'Suffix', context)
    );
  }

  return true;
};
